import React from "react";

const ResourcesContext = React.createContext([]);

export const ResourcesProvider = ResourcesContext.Provider;
export const ResourcesConsumer = ResourcesContext.Consumer;
export default ResourcesContext;
